import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getToken } from './Common'; // Adjust the path as needed

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      getToken() ? (
        <Redirect to="/dashboard" />
      ) : (
        <Component {...props} />
      )
    }
  />
);

export default PublicRoute;
